// extracted by mini-css-extract-plugin
export default {"FaqSectionMain":"Faqs_FaqSectionMain__xohdZ","FaqContent":"Faqs_FaqContent__qikGH"};